"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLinkTarget = exports.isActiveLink = exports.findActiveLink = void 0;
const epic_games_nav_shared_1 = require("epic-games-nav-shared");
const enhancedDropdownUtils_1 = require("./enhancedDropdownUtils");
const isLinkOptionActive = (linkOption = {}, locale) => {
    if (linkOption && (linkOption.active || (0, epic_games_nav_shared_1.hrefIsActive)(linkOption.href, locale))) {
        return true;
    }
    return false;
};
const findLinkOptionActiveKid = (linkOption = {}, locale) => {
    const kids = linkOption.kids || [];
    for (let j = 0; j < kids.length; j++) {
        const kid = kids[j];
        const kidActive = isLinkOptionActive(kid, locale);
        if (kidActive) {
            return kid;
        }
    }
    return null;
};
const findActiveLink = (linkOptions = [], locale) => {
    if (!linkOptions || !linkOptions.length)
        return { activeParent: null, activeKid: null };
    //look to see if any of the parents and their kids have the boolean flag 'active' to true and use this
    let activeKid = null;
    let activeParent = null;
    for (let i = 0; i < linkOptions.length; i++) {
        const linkOption = linkOptions[i];
        activeKid = findLinkOptionActiveKid(linkOption, locale);
        activeParent = linkOption;
        if (activeKid && activeParent)
            break;
    }
    if (!activeParent) {
        for (let i = 0; i < linkOptions.length; i++) {
            const linkOption = linkOptions[i];
            const linkActive = isLinkOptionActive(linkOption, locale);
            if (linkActive) {
                activeParent = linkOption;
                break;
            }
        }
    }
    return { activeParent, activeKid };
};
exports.findActiveLink = findActiveLink;
const isActiveLink = (linkOption = {}, locale) => {
    const isActive = isLinkOptionActive(linkOption, locale);
    if (isActive)
        return true;
    const activeKid = findLinkOptionActiveKid(linkOption, locale);
    if (activeKid)
        return true;
    if ((0, enhancedDropdownUtils_1.isValidEnhancedDropdown)(linkOption)) {
        const enhancedDropdown = linkOption.enhancedDropdown || {};
        const externalColumn = enhancedDropdown.externalColumn || {};
        const externalLinks = externalColumn.links || [];
        for (let i = 0; i < externalLinks.length; i++) {
            const foundActive = isLinkOptionActive(externalLinks[i], locale);
            if (foundActive)
                return true;
        }
    }
    return isActive;
};
exports.isActiveLink = isActiveLink;
/**
 * getLinkTarget determined the right link target based on the link's properties.
 * Suitable for legacy links, do not use in combination with custom LinkComponents
 * as external href's are now in link.hrefTemplate and not link.href
 */
const getLinkTarget = (link) => {
    if (link.target)
        return link.target;
    if (link.arrowIcon)
        return "_blank";
    if (link.href) {
        const { isExternal, sameOrigin } = (0, epic_games_nav_shared_1.determineExternal)(link.href);
        const safe = !isExternal || sameOrigin;
        if (!safe) {
            return "_blank";
        }
    }
    return "";
};
exports.getLinkTarget = getLinkTarget;
//# sourceMappingURL=mainLinkUtils.js.map